import React from 'react';
import PropTypes from 'prop-types';

import styles from '../productPurchaseCard/ProductPurchaseCard.m.sass';

import FieldRadio from '../../fields/fieldRadio/FieldRadio';
import Pricing from '../../pricing/Pricing';


export default function RadioGroupVariantPicker({availableVariants, selectedVariant, onChange}) {
  return availableVariants.sort((a, b) => a.position - b.position).map(variant => (
    <FieldRadio
      key={variant.id}
      input={{
        value: variant.id,
        checked: variant.id === selectedVariant.id,
        onChange: () => onChange(variant),
      }}
    >
      <span className={styles.productCard_optionText}>{variant.name}</span>

      <Pricing
        small
        value={variant.price}
      />
    </FieldRadio>
  ));

}

RadioGroupVariantPicker.propTypes = {
  availableVariants: PropTypes.array.isRequired,
  selectedVariant: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./components/productPurchase/variantPickers/RadioGroupVariantPicker.js